import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "reduxUtils/store";

/**
 * select the current rates based on the current contract and time
 */
export const selectLatestTwoInvoice = createSelector(
  (state: RootState) => state.currentInvoices?.currentLatestInvoices,
  (latestInvoices) => {
    if (!latestInvoices) return undefined;

    return latestInvoices.slice(0, 2);
  },
);
